// TODO: return string as formatted kilowatts to keep format consistent across app
export const toKilowatts = (wattValue: number): number => {
  return Math.round(wattValue / 1000);
};
